import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MatDialog } from '@angular/material/dialog';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AddFutureBookingsComponent } from 'src/app/shared/components/add-future-bookings/add-future-bookings.component';

@Component({
  selector: 'sm-service-performance-report',
  templateUrl: './service-performance-report.component.html',
  styleUrls: ['./service-performance-report.component.scss']
})
export class ServicePerformanceReportComponent implements OnInit, OnDestroy {
  selectedFrequency: any = 1
  // frequencyOfView: any
  selectedView: any = 'Data'
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  pageTitle: string = 'Booking History' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;
 
  fromDate:any = new Date();
  toDate:any = new Date();
  today: string = new Date().toISOString().slice(0,10)
  serviceReportData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant('service_report.column_headers.name'),
      columnProperty: "service_name"
    },
    {
      columnName: this.translateService.instant('service_report.column_headers.total'),
      columnProperty: "total_revenue"
    },
    {
      columnName: this.translateService.instant('service_report.column_headers.bookings'),
      columnProperty: "total_bookings"
      },
      {
        columnName: this.translateService.instant('service_report.column_headers.shop'),
        columnProperty: "shop_booking"
        },
        {
          columnName: this.translateService.instant('service_report.column_headers.home'),
          columnProperty: "home_booking"
          },
        {
          columnName: 'Virtual sales',
          columnProperty: "virtual_booking"
          },
            {
              columnName: this.translateService.instant('service_report.column_headers.completed'),
              columnProperty: "completed_qty"
            },
    
  ];
  
  private _apiSubscription: Subscription;
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, private loaderservice: LoaderServiceService, public _modelRef: MatDialog, private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private translateService: TranslateService) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_SERVICE_REPORT){
        this.serviceReportData = []
        if(true){
          this.serviceReportData = resData.result ? resData.result : [] 

          //graph assign
          this.graphData = {
            datasets: [{
                label: 'Service Performance',
                data: this.serviceReportData.map(item => {
                  return item.total_revenue
              }),
                // backgroundColor: "rgb(115 185 243 / 65%)",
                backgroundColor: this.serviceReportData.map(item => {
                  return '#007ee7'
              }),
                borderColor: this.serviceReportData.map(item => {
                  return '#007ee7'
              }),
                borderWidth: 1,
                categoryPercentage: 0.5,
            }],      
            labels: this.serviceReportData.map(item => {
              return item.service_name
          })
    
        }
        }
        this.visible = true
        this.loaderservice.showLoader = false
      }
    })
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
   }

   private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "name",
        "total",
        "bookings",
        "shop",
        "home",
        "completed"
      ]
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`service_report.column_headers.${data[index]}`);
    });
  }
  ngOnInit(): void {
   
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.fromDate.setDate(this.fromDate.getDate() - 30);
    this.fromDate = this.fromDate.toISOString().slice(0,10);
    this.toDate = this.toDate.toISOString().slice(0,10);
    this.loaderservice.showLoader = true
    this.visible = false
    this._apiService.getServiceReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate))


  }
  search(){
       // Ensure date range is valid based on the selected frequency
       const fromDate = new Date(this.fromDate);
       const toDate = new Date(this.toDate);
   
       if (this.selectedFrequency === 1) { // Daily
         const maxRange = 90;
         const range = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 90 days.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       } else if (this.selectedFrequency === 2) { // Monthly
         const maxRange = 36;
         const range = (toDate.getMonth() - fromDate.getMonth() + (12 * (toDate.getFullYear() - fromDate.getFullYear())));
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 3 years.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       }
   
       //end
    if(this.selectedFrequency == 2){
      this.tableDisplayColumns = [
        {
          columnName: this.translateService.instant('service_report.column_headers.name'),
          columnProperty: "service_name"
        },
        {
          columnName: this.translateService.instant('service_report.column_headers.total'),
          columnProperty: "total_revenue"
        },
        {
          columnName: this.translateService.instant('service_report.column_headers.bookings'),
          columnProperty: "total_bookings"
          },
          {
            columnName: this.translateService.instant('service_report.column_headers.shop'),
            columnProperty: "shop_booking"
            },
            {
              columnName: this.translateService.instant('service_report.column_headers.home'),
              columnProperty: "home_booking"
              },
            {
              columnName: 'Virtual sales',
              columnProperty: "virtual_booking"
              },
                {
                  columnName: this.translateService.instant('service_report.column_headers.completed'),
                  columnProperty: "completed_qty"
                },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getServiceReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
    else{
      this.tableDisplayColumns = [
        {
          columnName: this.translateService.instant('service_report.column_headers.name'),
          columnProperty: "service_name"
        },
        {
          columnName: this.translateService.instant('service_report.column_headers.total'),
          columnProperty: "total_revenue"
        },
        {
          columnName: this.translateService.instant('service_report.column_headers.bookings'),
          columnProperty: "total_bookings"
          },
          {
            columnName: this.translateService.instant('service_report.column_headers.shop'),
            columnProperty: "shop_booking"
            },
            {
              columnName: this.translateService.instant('service_report.column_headers.home'),
              columnProperty: "home_booking"
              },
            {
              columnName: 'Virtual sales',
              columnProperty: "virtual_booking"
              },
                {
                  columnName: this.translateService.instant('service_report.column_headers.completed'),
                  columnProperty: "completed_qty"
                },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getServiceReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
  }

  changeFrequency(){
    if(this.selectedFrequency == 2){

      this.tableDisplayColumns = [
        {
          columnName: 'month',
          columnProperty: "month"
        },
        {
          columnName: 'total sales',
          columnProperty: "totalSales"
        },
        {
          columnName: 'home sales',
          columnProperty: "homeSales"
        },
        {
          columnName: 'shop sales',
          columnProperty: "shopSales"
        },
        

      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getServiceReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
    else{
      this.fromDate = new Date()
      this.toDate = new Date()
      this.fromDate.setDate(this.fromDate.getDate() - 30);
      this.fromDate = this.fromDate.toISOString().slice(0,10);
      this.toDate = this.toDate.toISOString().slice(0,10);
      this.tableDisplayColumns = [
        {
          columnName: 'date',
          columnProperty: "date"
        },
        {
          columnName: 'total sales',
          columnProperty: "totalSales"
        },
        {
          columnName: 'home sales',
          columnProperty: "homeSales"
        },
        {
          columnName: 'shop sales',
          columnProperty: "shopSales"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getServiceReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
  }
 
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
 
   
  toShowGraph: boolean = false
  graphData: any
  changeView(){
    if(this.selectedView == 'Data'){
      this.toShowGraph = false
    }else if(this.selectedView == 'Graph'){
    
      this.graphData = {
        datasets: [{
            label: 'Service Performance',
            data: this.serviceReportData.map(item => {
              return item.total_revenue
          }),
            // backgroundColor: "rgb(115 185 243 / 65%)",
            backgroundColor: this.serviceReportData.map(item => {
              return '#007ee7'
          }),
            borderColor: this.serviceReportData.map(item => {
              return '#007ee7'
          }),
            borderWidth: 1,
            categoryPercentage: 0.5,
        }],      
        labels: this.serviceReportData.map(item => {
          return item.service_name
      })

    }
    this.toShowGraph = true
    }
    
  }

  formatDate1(dateStr:Date) {

    let curdate = new Date(dateStr).toLocaleString('en-CA', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
  }).slice(0, 10);
      console.log(curdate);
      
      return curdate
  }


}

